module.exports = __webpack_public_path__ + "img/00023.2f0045b2.webp";